<template>

    <div class="login-container min-vh-100 d-flex align-items-center">
        <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 col-xl-6 col-xl-offset-3 login-box d-block mx-auto new_login_data">
            <div class="login-header">
                <img src="https://app.spendid.io/footer-logo.png" />
                <!-- <h3>Welcome</h3>
                <h5>PLEASE LOG IN</h5> -->
            </div>
            <div id="error-message" class="alert alert-danger"></div>
            <form onsubmit="return false;" v-if="!forget" method="post" class="cstm-login-form">
                <div class="left-content">
                    <button type="button" @click="fbLogin('facebook')" id="btn-facebook" class="btn btn-default btn-danger btn-block">
                        <span class="common-icon facbook-icon"></span>
                        Log In with facebook
                    </button>
                    <button type="button"  @click="fbLogin('twitter')" id="btn-twitter" class="btn btn-default btn-danger btn-block">
                        Log In with Twitter
                        <span class="common-icon twiter-icon"></span>
                    </button>
                    <button type="button"  @click="fbLogin('google-oauth2')" id="btn-google" class="btn btn-default btn-danger btn-block">
                        Log In with Google+
                        <span class="common-icon google-icon"></span>
                    </button>
                    <div class="or-wrap">
                        <p>Or</p>
                    </div>
                </div>
                <div class="right-content">
                    <h5>Login In</h5>
                      <p v-if="errors.length">
                        <b>Please correct the following error(s):</b>
                        <ul>
                            <li v-for="(error,i) in errors" :key="i">{{ error }}</li>
                        </ul>
                    </p>

                    <div class="form-group">
                        <input type="email" class="form-control" v-model="form.email"  id="email" placeholder="Username or email">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" v-model="form.password" id="password" placeholder="Password">
                    </div>
                    <div class="captcha-container form-group"></div>
                    <div class="btn-wrap">
                        <div class="form-group form-check">
                            <span role="button" @click="forget=true">Forgot password</span>
                        </div>
                        <button type="submit" @click="submitForm()" id="btn-login" class="btn btn-primary btn-block">
                            Log In
                        </button>
                    </div>
                    <div class="btn-wrap forgot-wrap">
                    </div>
                </div>


            </form>

            <div v-if="forget" class="col-lg-6 offset-lg-3 mt-5">
                 <form class="cstm-login-form2">
                    <div class="form-group">
                        <input type="email" class="form-control" v-model="forgetform.email"  id="email" placeholder="Enter an email">
                    </div>
                    <div class="form-group">
                        <div class="btn-wrap">
                            
                            <div class="form-group form-check">
                                <span role="button" @click="forget=false">Return to login</span>
                            </div>
                            <button type="button" @click="forgotPassword()" id="btn-login" class="btn btn-primary btn-block">
                            Submit
                            </button>
                        </div>
                    </div>
                 </form>
            </div>
            </div>

        </div>

</template>
<script>

import { connection, clientId, domain, node_url  } from "../auth_config.json"
export default {
    
  name: "landing-app",   
  data() {  
        return {
            form:{
                email:'', 
                password:'',
            },
            forgetform:{
                client_id: clientId,
                email: "",
                connection
            },
            errors:[],
            forget:false
        };
    },
  mounted(){
       let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://cdn.auth0.com/js/auth0/9.11/auth0.min.js')
      document.head.appendChild(recaptchaScript)
  },
  created(){
 
  },
  methods:{
      fbLogin(connection){
             var webAuth = new auth0.WebAuth({
                domain,
                clientID: clientId
            });
            webAuth.authorize({
                connection,
                responseType :'token',
                redirectUri:'https://app.spendid.io/'
            });
      },
      async submitForm(){
        this.errors = [];

        if (!this.form.email) {
            this.errors.push('Email required.');
        }
        if (!this.form.password) {
            this.errors.push('Password required.');
        }
        if(this.errors.length==0){
          const URI = node_url;
          const config = {
              headers: { "Content-Type": "application/json" },
          }
          try{
            const result = await this.$http.post(URI, this.form, config);
            if(result.data.access_token){
                this.$router.push('/') 
            } else {
                this.errors.push('Something went wrong');
            }
          } catch(err){
              this.errors.push('Invalid email or password');
            //   console.log(err);
          }
        }
      },
      async forgotPassword(){
          const URI = `https://${domain}/dbconnections/change_password`;
          const config = {
              headers: { "Content-Type": "application/json" },
          }
          const result = await this.$http.post(URI, this.forgetform, config);
          if(result){
              this.forgetform.email=''
              alert(result.data)
          }
      }
  }
}
</script>
<style>
    body,
    html {
        height: 100%;
        background-color: #f9f9f9;
    }

    .login-container {
        position: relative;
        height: 100%;
    }

    .login-box {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        padding: 15px;
        background-color: #fff;
        box-shadow: 0px 5px 5px #ccc;
        border-radius: 10px;
        border-top: 1px solid #e9e9e9;
    }

    .login-header {
        text-align: center;
    }

    button#btn-twitter:hover {
        background: #4b9bd7;
        border-color: #4b9bd7;
    }

    button#btn-facebook:hover {
        background: #324979;
        border-color: #324979;
    }


    .login-header img {
        width: 115px;
    }

    #error-message {
        display: none;
        white-space: break-spaces;
    }

    #btn-twitter {
        background: #55acee;
        border-color: #55acee;
        height: 60px;
        border-radius: 10px;
        margin-bottom: 30px;
        font-weight: 600;
    }

    #btn-facebook {
        background: #3b5998;
        border-color: #3b5998;
        height: 60px;
        border-radius: 10px;
        margin-bottom: 30px;
        font-weight: 600;
    }

    #btn-google {
        height: 60px;
        border-radius: 10px;
        font-weight: 600;
    }

    .cstm-login-form {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0 50px;
    }

    .cstm-login-form .left-content {
        width: 50%;
        padding: 0 70px;
        border-right: 2px solid #eee;
        position: relative;
    }

    .or-wrap p {
        height: 50px;
        width: 50px;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        font-size: 16px;
        font-weight: 700;
        border: 2px solid #eee;
        position: absolute;
        top: 50%;
        right: -26px;
        text-transform: uppercase;
        transform: translatey(-50%);
    }

    .cstm-login-form .right-content {
        width: 50%;
        padding: 0 70px;
    }

    .cstm-login-form input {
        height: 60px;
        border-radius: 10px;
    }

    input {
        background-color: #eeeeee;
    }

    .btn-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
    }

    #btn-login {
        height: 60px;
        border-radius: 10px;
        font-weight: 600;
        background: #3ab7a4;
        border-color: #3ab7a4;
        width: 130px;
    }

    .cstm-login-form .form-group.form-check {
        display: flex;
        align-items: center;
        margin-bottom: 0;
    }

    .cstm-login-form .form-group.form-check input#exampleCheck1 {
        height: auto;
        margin-right: 10px;
        margin-top: 0;
    }

    .cstm-login-form .form-group.form-check label {
        margin-bottom: 0px;
    }

    .cstm-login-form button#btn-signup {
        width: auto;
        border: none;
        font-size: 16px;
        background: transparent;
        padding: 0;
        font-weight: 600;
        color: #3ab7a4;
        /* border-right: 2px solid #bbbbbb; */
        border-radius: 0;
        /* margin-right: 25px;
        padding-right: 25px; */
    }

    button:focus,
    input:focus {
        outline: none !important;
        box-shadow: none !important;
    }

    input:focus {
        border-color: #eee !important;
    }

    .cstm-login-form a {
        margin-bottom: 0;
        color: #a2a2a2;
        font-weight: 700;
    }

    .btn-wrap.forgot-wrap {
        justify-content: flex-start;
        margin-top: 15px;
    }

    .forgot-link {
        font-weight: 600;
        color: #000;
        font-size: 16px;
    }

    .right-content h5 {
        text-align: center;
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 20px;
        color: #3ab7a4;
    }

    a:hover {
        text-decoration: none;
    }

    .cstm-login-form input::placeholder,
    .cstm-login-form input {
        font-weight: 500;
        color: #000;
        border-color: #eeeeee !important;
        background-color: #eeeeee;
        outline: none;
        box-shadow: none;
    }

    .left-content button {
        position: relative;
    }

    .twiter-icon {

        background-image: url(data:image/svg+xml;base64,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);

    }

    .facbook-icon {

        background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMjIuNjY2NjY2NywwIEwxLjMzMzMzMzMzLDAgQzAuNTk2OTUzNjY3LC00LjUwOTAyNTAxZS0xNyA5LjAxODA1MDAxZS0xNywwLjU5Njk1MzY2NyAwLDEuMzMzMzMzMzMgTDAsMjIuNjY2NjY2NyBDOS4wMTgwNTAwMWUtMTcsMjMuNDAzMDQ2MyAwLjU5Njk1MzY2NywyNCAxLjMzMzMzMzMzLDI0IEwxMi44MiwyNCBMMTIuODIsMTQuNzIgTDkuNzAzMzMzMzMsMTQuNzIgTDkuNzAzMzMzMzMsMTEuMDg2NjY2NyBMMTIuODIsMTEuMDg2NjY2NyBMMTIuODIsOC40MiBDMTIuODIsNS4zMiAxNC43MTMzMzMzLDMuNjMgMTcuNDg2NjY2NywzLjYzIEMxOC40MTk2ODM2LDMuNjI3MjczMzEgMTkuMzUyMTYyNSwzLjY3NTEyMTI4IDIwLjI4LDMuNzczMzMzMzMgTDIwLjI4LDcgTDE4LjM2NjY2NjcsNyBDMTYuODYzMzMzMyw3IDE2LjU3LDcuNzE2NjY2NjcgMTYuNTcsOC43NjY2NjY2NyBMMTYuNTcsMTEuMDggTDIwLjE2NjY2NjcsMTEuMDggTDE5LjcsMTQuNzEzMzMzMyBMMTYuNTcsMTQuNzEzMzMzMyBMMTYuNTcsMjQgTDIyLjY2NjY2NjcsMjQgQzIzLjQwMzA0NjMsMjQgMjQsMjMuNDAzMDQ2MyAyNCwyMi42NjY2NjY3IEwyNCwxLjMzMzMzMzMzIEMyNCwwLjU5Njk1MzY2NyAyMy40MDMwNDYzLDQuNTA5MDI1MDFlLTE3IDIyLjY2NjY2NjcsMCBaIiBpZD0iUGF0aCIgZmlsbD0iI0ZGRkZGRiI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4=);

    }

    .google-icon {

        background-image: url(data:image/svg+xml;base64,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);


    }
    .new_login_data {
        transform: initial !important;
        -webkit-transform: initial !important;
        top:0;
        position: relative;
    }   

    .common-icon {
        box-sizing: content-box;
        width: 25px;
        background-size: 100%;
        height: 25px;
        position: absolute;
        top: 52%;
        left: 40px;
        transform: translateY(-50%);
        transition: background-color 0.3s, border 0.2s ease-in-out;
        -webkit-transition: background-color 0.3s, border 0.2s ease-in-out;
        background-size: contain;
        background-repeat: no-repeat;
    }

    .cstm-login-form2 input::placeholder, .cstm-login-form2 input {
        font-weight: 500;
        color: #000;
        border-color: #eeeeee !important;
        background-color: #eeeeee;
        outline: none;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .cstm-login-form2 input {
        height: 60px;
        border-radius: 10px;
    }
    
    @media all and (max-width: 1880px){
        .cstm-login-form .left-content,
        .cstm-login-form .right-content{
            padding: 0 45px;
        }
    }
    @media all and (max-width: 1700px){
        .cstm-login-form .left-content span.common-icon {
            position: relative;
            transform: initial !important;
            top: 0 !important;
            display: block;
            left: 0;
            margin-right: 10px;
            order: -1;
            -webkit-order: -1;
        }
        .cstm-login-form .left-content button {
            display: flex;
            align-items: center;
            justify-content: center;
            display: -webkit-flex;
            -webkit-align-items: center;
            -webkit-justify-content: center;
        }
    }
    @media all and (max-width:767px){
        .cstm-login-form .left-content, .cstm-login-form .right-content{
            width: 100%;
        }
        .cstm-login-form {
            flex-wrap: wrap;
            -webkit-flex-wrap: wrap;
        }
        .cstm-login-form .left-content {
            margin-bottom: 40px;
            border: none;
        }
        .cstm-login-form .left-content button {
            margin: 10px 0 !important;
        }
        .cstm-login-form .left-content .or-wrap {
            display: none;
        }
    }
</style>
